import { c as _c } from "react/compiler-runtime";
import { getCurrencyKey } from "@opensea/app-kit";
import { AnimatedNumber, Flex, ListItem, ListItemAvatar, ListItemContent, ListItemDescription, ListItemSide, ListItemTitle, SkeletonCircle, SkeletonLine, StatChange, Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { CurrencyItemChainBadge } from "../../../../../components/CurrencyQuantityInput/CurrencyItemChainBadge";
import { useNavigation } from "../../../../../providers/NavigationProvider";
export function CurrencyBalanceItem(t0) {
  const $ = _c(39);
  const {
    currency,
    quantity,
    usdValue,
    showCurrencyUsdValue: t1,
    variant: t2,
    withLink: t3
  } = t0;
  const showCurrencyUsdValue = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "marketCap" : t2;
  const withLink = t3 === undefined ? false : t3;
  const t = useTranslations("wallet.CurrencyBalanceItem");
  const {
    renderLink: Link,
    onClick
  } = useNavigation();
  const tokenUrl = `/token/${currency.chainIdentifier}/${currency.contractAddress}`;
  let t4;
  if ($[0] !== currency.chainIdentifier) {
    t4 = <CurrencyItemChainBadge identifier={currency.chainIdentifier} />;
    $[0] = currency.chainIdentifier;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== currency) {
    t5 = getCurrencyKey(currency);
    $[2] = currency;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== currency.imageUrl || $[5] !== t4 || $[6] !== t5) {
    t6 = <ListItemAvatar badge={t4} className="bg-bg-additional-1" rounded={true} seed={t5} size={42} src={currency.imageUrl} />;
    $[4] = currency.imageUrl;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== currency.name) {
    t7 = <ListItemTitle>{currency.name}</ListItemTitle>;
    $[8] = currency.name;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== currency.symbol || $[11] !== quantity) {
    t8 = <ListItemDescription><AnimatedNumber display="standard" suffix={currency.symbol} value={quantity} /></ListItemDescription>;
    $[10] = currency.symbol;
    $[11] = quantity;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <ListItemContent>{t7}{t8}</ListItemContent>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = showCurrencyUsdValue ? currency.usdPrice : usdValue;
  let t11;
  if ($[16] !== t10) {
    t11 = <ListItemTitle><AnimatedNumber display="usd" value={t10} /></ListItemTitle>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== currency.stats || $[19] !== t || $[20] !== variant) {
    t12 = variant === "marketCap" && currency.stats?.marketCapUsd && <Tooltip content={t("marketCapTooltip")}><ListItemDescription className="font-mono"><AnimatedNumber display="usd" value={currency.stats.marketCapUsd} />{" "}{t("marketCap")}</ListItemDescription></Tooltip>;
    $[18] = currency.stats;
    $[19] = t;
    $[20] = variant;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== currency.stats || $[23] !== t || $[24] !== variant) {
    t13 = variant === "24h" && currency.stats?.oneDay?.priceChange !== undefined && currency.stats?.oneDay?.priceChange !== null && <Tooltip content={t("priceChangeTooltip")}><ListItemDescription><StatChange change={Number(currency.stats.oneDay.priceChange)} /></ListItemDescription></Tooltip>;
    $[22] = currency.stats;
    $[23] = t;
    $[24] = variant;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t13) {
    t14 = <ListItemSide className="items-end">{t11}{t12}{t13}</ListItemSide>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14 || $[31] !== t6 || $[32] !== t9) {
    t15 = <ListItem className="-mx-2 grow rounded-md p-2" interactive={true}>{t6}{t9}{t14}</ListItem>;
    $[30] = t14;
    $[31] = t6;
    $[32] = t9;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const content = t15;
  if (!withLink) {
    return content;
  }
  let t16;
  if ($[34] !== Link || $[35] !== content || $[36] !== onClick || $[37] !== tokenUrl) {
    t16 = <Link className="w-full" href={tokenUrl} onClick={onClick}>{content}</Link>;
    $[34] = Link;
    $[35] = content;
    $[36] = onClick;
    $[37] = tokenUrl;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}
export function CurrencyBalanceItemSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SkeletonCircle className="size-10" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Flex className="h-6 items-center"><SkeletonLine className="h-4 w-[120px]" /></Flex>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ListItemContent>{t1}<ListItemDescription><SkeletonLine className="h-[14px] w-[80px]" /></ListItemDescription></ListItemContent>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Flex className="h-6 items-center"><SkeletonLine className="h-4 w-[80px]" /></Flex>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ListItem className="cursor-pointer border border-border-2 p-2 no-underline hover:bg-bg-additional-1 active:bg-bg-additional-2 disabled:pointer-events-none disabled:opacity-40">{t0}{t2}<ListItemSide className="items-end">{t3}<Flex className="h-4 items-center"><SkeletonLine className="h-[14px] w-[50px]" /></Flex></ListItemSide></ListItem>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}